import React, { useState, useEffect,useRef } from 'react';
import '../styles/myRequests.css';
import { Icon, IconButton } from '@fluentui/react';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { useApiService } from '../services/apiServices';
import { useNavigate } from 'react-router-dom';
import AdvancedSearch from '../components/adminAdvancedSearch';
import {Button} from "@mui/material";
import clearicon from '../assets/closecircle.svg'; 
import emptybackground from '../assets/nofile.png';
import HistoryOutlinedIcon from '../assets/historyicon.png';
import useAffidavitService from '../services/affidavitServices';
import {
    Refresh
} from "@mui/icons-material";

initializeIcons();

const RequestsList = ({affidavitRequests, courts, courtDivisions, loading, setLoading}) => {
    const searchInputRef = useRef(null); // Create a ref for the input field
    const [allAffidavitRequests, setAllAffidavitRequests] = useState([]);
    const [filteredAffidavitRequests, setFilteredAffidavitRequests] = useState([]);
    const [courtDivisionsForCourt, setCourtDivisionsForCourt] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [selectedCourtId, setSelectedCourtId] = useState("");
    const [selectedCourtDivisionId, setSelectedCourtDivisionId] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(15);
    const [tableHeight, setTableHeight] = useState('auto');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentDocumentUrl, setCurrentDocumentUrl] = useState('');
    const [isAdvancedSearchOpen, setIsAdvancedSearchOpen] = useState(false);
    const [message, setMessage] = useState("");
    const { fetchAllAffidavitData} = useAffidavitService();
    const searchBoxStyles = {
        container: {
          display: "flex",
          alignItems: "center",
          border: "1px solid #0A722F",
          borderRadius: "10px",
          overflow: "hidden",
        //   width: "250px",
          marginTop: "auto"
        },
        input: {
          flex: 1,
          border: "none",
          outline: "none",
          padding: "10px 15px",
          fontSize: "14px",
          color: "#333",
          "::placeholder": {
            color: "#B0B0B0",
          },
        },
        button: {
          backgroundColor: "#0A722F",
          height: "100%",
          color: "#fff",
          padding: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "15%",
          cursor: "pointer",
        },
      };
      
    const navigate = useNavigate();
    
    const handleDownload = (documentUrl) => {
       const viewerUrl = `/pdfjs/viewer.html?file=${encodeURIComponent(documentUrl)}`;
        setCurrentDocumentUrl(viewerUrl);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setCurrentDocumentUrl('');
    };


    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;

            if (width >= 1200) { // Large screens 800
                setItemsPerPage(20);
                setTableHeight('auto');
            } else if (width >= 768) { // Medium screens 600
                setItemsPerPage(20);
                setTableHeight('auto');
            } else { // Small screens 400
                setItemsPerPage(5);
                setTableHeight('auto');
            }
        };

        // Set initial value on mount
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            
            try {
                if (affidavitRequests && affidavitRequests.length > 0) {
                    processAffidavitRequests(affidavitRequests);
                } else {
                    console.log(loading)
                    setMessage("No requests have been submitted yet.");
                }
            } catch (error) {
                console.error("Failed to fetch data:", error);
                setMessage("An error occurred while processing your data. Please try again later");
            }
        };

        fetchData();
    }, [affidavitRequests,courts,courtDivisions]);

    const processAffidavitRequests = (requests) => {
        const latestAffidavit = requests.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
        setAllAffidavitRequests(latestAffidavit);
        setFilteredAffidavitRequests(latestAffidavit);

        if (latestAffidavit.length === 0) {
            setMessage("No requests have been submitted yet.");
        }
    };

    const handleFiltering = (courtId, courtDivisionId, searchValue) => {
        let filteredRequests = allAffidavitRequests;

        if (courtId) {
            courtId = parseInt(courtId);
            if (courtId !== 0) {
                filteredRequests = filteredRequests.filter((affidavit) => affidavit.courtId === courtId);
            }
        }
        
        if (courtDivisionId) {
            courtDivisionId = parseInt(courtDivisionId);
            if (courtDivisionId !== 0) {
                filteredRequests = filteredRequests.filter((affidavit) => affidavit.courtDivisionId === courtDivisionId);
            }
        }
        
        if (searchValue) {
            filteredRequests = filteredRequests.filter((affidavit) => affidavit.documentId.includes(searchValue));
        }

        setFilteredAffidavitRequests(filteredRequests);
        setMessage("Your search did not return any results. Please check your search criteria and try again");
        setCurrentPage(1);
    }

    const handleRefresh = async() => {
        try
            {
                setLoading(true);
                const fetchedaffidavitrecord = await fetchAllAffidavitData();
                if (fetchedaffidavitrecord && fetchedaffidavitrecord.length > 0) {
                    processAffidavitRequests(fetchedaffidavitrecord);
                } else {
                    setMessage("No requests have been submitted yet.");
                }
            }
            catch(error)
            {
            console.error("Failed to refresh data:", error);
            throw error;
            }finally
            {
                setLoading(false);
            }
            }

    const handleSearchTextChange = () => {
        const searchValue = searchInputRef.current.value;
        setSearchText(searchValue);
        handleFiltering(selectedCourtId, selectedCourtDivisionId, searchValue);
    }

    // Handle dropdown changes and filter
    const handleCourtDropdownChange = (event) => {
        const courtId = event.target.value;
        setSelectedCourtDivisionId("");
        setSelectedCourtId(courtId);

        if (courtId === "0") {
            setCourtDivisionsForCourt([{ id: 0, courtDivisionName: "All" }]);
        } else {
            let courtDivisionsForSelectedCourt = courtDivisions.filter((division) => division.courtId === parseInt(courtId));
            courtDivisionsForSelectedCourt.unshift({ id: 0, courtDivisionName: "All" });
            setCourtDivisionsForCourt(courtDivisionsForSelectedCourt);
        }

        handleFiltering(courtId, "", searchText);
    }

    const handleCourtDivisionDropdownChange = (event) => {
        setSelectedCourtDivisionId(event.target.value);
        handleFiltering(selectedCourtId, event.target.value, searchText);
    }

    const handleClearButtonClick = () => {
        setSearchText("");
        setSelectedCourtId("");
        setSelectedCourtDivisionId("");
        searchInputRef.current.value = ""; // Clear the input field
        handleFiltering("", "", "");
    }

    const handleOpenAdvancedSearch = () => {
        setIsAdvancedSearchOpen(!isAdvancedSearchOpen);
    }

    const handleAffidavitRequestsSearchResults = (requests) => {
        setFilteredAffidavitRequests(requests)
        if(requests.length === 0){
            setMessage("Your search did not return any results. Please check your search criteria and try again");
        }
    }
    const handleSignatureClick = (documentUrl,id) => {
        console.log("idtoedit",id);
        navigate(`/signature?pdfUrl=${encodeURIComponent(documentUrl)}&id=${encodeURIComponent(id)} &page=all`);
    }

    const handleHistoryClick = (id) => {
          navigate(`/search-request?id=${encodeURIComponent(id)}`);
      };

    // Pagination Logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredAffidavitRequests.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredAffidavitRequests.length / itemsPerPage);

    return (
        <div  className='container-content'>
             <div className="page-title">
                <p>Request List</p>
            </div>
            <div className="search-and-filter-container">
            <div className="filter-container">
                <div className="search-box-container" style={searchBoxStyles.container}>
                
                                                <input
                                                    type="text"
                                                    placeholder="Search by Document Id"
                                                    defaultValue={searchText} // Use value instead of defaultValue
                                                    ref={searchInputRef}
                                                    className="search-input"
                                                    style={searchBoxStyles.input}
                                                />
                                                <IconButton
                                                    iconProps={{ iconName: "Search" }}
                                                    style={searchBoxStyles.button}
                                                    onClick={() => handleSearchTextChange()}
                                                />
                        </div>
                    {/* <button className="filter-button" onClick={handleFiltering}>Filter</button> */}
                    <div className="select-group">
                    <div className="select-item">
                        <label htmlFor="court-select"> Filter by court name</label>
                        <select
                            id="court-select"
                            className="select-left"
                            value={selectedCourtId}
                            onChange={handleCourtDropdownChange}
                        >
                            <option value="" disabled hidden>
                                All Courts
                            </option>
                            {courts.length > 0 && courts.map((court) => {
                                return <option value={court.id} key={court.id}>{court.courtName}</option>
                            })}
                        </select>
                    </div>
                    <div className="select-item">
                        <label htmlFor="division-select"
                               disabled={!selectedCourtId}>Filter by division</label>
                        <select
                            id="division-select"
                            value={selectedCourtDivisionId}
                            onChange={handleCourtDivisionDropdownChange}
                            className="select-right"
                            disabled={!selectedCourtId}
                        >
                            <option value="" disabled hidden>
                                All Divisions
                            </option>
                            {courtDivisionsForCourt.map((division) => {
                                return <option value={division.id} key={division.id}>{division.courtDivisionName}</option>
                            })}
                        </select>
                    </div>
                    </div>
                            <div className="button-group">
                                <button className="clear-button" onClick={handleClearButtonClick}>
                                    <img src={clearicon} alt="Clear Icon" />
                                    Reset
                                </button>
                                <button className="clear-button"  onClick={() => handleRefresh()}>
                                   <Refresh/>
                                    Refresh
                                </button>
                                <button className="mrl-btn mrl-btn-advanced" onClick={handleOpenAdvancedSearch}>Advanced Search</button>             
                 
                            </div>
                
            </div>
            </div>
             {loading ? ( 
                    <div className="loader"></div>
                ) : filteredAffidavitRequests.length  == 0 ? (

                    <div className="emptytext">
                        <img src={emptybackground} alt='no file image'/>
                        <p style={{ fontStyle: 'italic' }}>
                        {message ? message : "An error occurred while processing your data. Please try again later"}
                        </p>
                         </div>
                ) : (
            <div className='table-wrapper' style={{ Height: tableHeight }}>
                    
                    <table className="requests-table">
                        <thead>
                            <tr>
                                <th>Document ID</th>
                                <th>Date</th>
                                <th>Court Name</th>
                                <th>Court Division</th>
                                <th>Deponent Name</th>
                                <th>Current Status</th>
                                <th>Court Staff</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map((row, index) => (
                                <tr key={index} className="request-row">
                                    <td>{row.documentId}</td>
                                    <td>{new Date(row.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-')}</td>
                                    <td>{row.court?.courtName}</td>
                                    <td>{row.courtDivision?.courtDivisionName}</td>
                                    <td>{row.deponentName}</td>
                                    <td>
                                    <span
                                        style={{
                                            backgroundColor: row.status === 'Approved' ? '#2BA745' : row.status === 'Rejected' ? '#721c24' : row.status === 'Cancelled' ? '#808080' : '#FFA500',
                                            color: 'white',
                                            borderRadius: '4px',
                                            padding: '5px 10px',
                                            textAlign: 'center',
                                            width: '100px', // Set a fixed width
                                            display: 'inline-block', 
                                        }}
                                        >
                                    {row.status}
                                    </span>
                                    </td>                     
                                    <td>{row.adminOfficer ? row.adminOfficer : "Not Assigned"}</td>
                                    <td>
                                        <div style={{ display: 'flex', justifyContent: 'space-around',gap: "16px" }}>
                                        <IconButton
                                            iconProps={{ iconName: 'View' }}
                                            title='view document'
                                            onClick={() => handleDownload(row.signedDocumentUrl ? row.signedDocumentUrl : row.documentUrl)}
                                            styles={{
                                                root: {
                                                    color: 'black',
                                                    width: '20px',
                                                    height: '20px'
                                                },
                                                menuIcon: {
                                                    fontSize: '18',
                                                    marginLeft: '12px'
                                                }
                                            }}
                                        />
                                    <IconButton
                                            iconProps={{ iconName: 'History' }}
                                            title='view more details'
                                            onClick={() => handleHistoryClick (row.documentId)}
                                            styles={{
                                                root: {
                                                    color: 'black',
                                                    width: '20px',
                                                    height: '20px'
                                                },
                                                menuIcon: {
                                                    fontSize: '18',
                                                    marginLeft: '12px'
                                                }
                                            }}
                                        />

                                        <IconButton
                                            iconProps={{ iconName: 'Edit' }}
                                            disabled={row.status !== 'Pending'}
                                            title='edit document'
                                            onClick={() => handleSignatureClick(row.documentUrl,row.documentId)}
                                            styles={{
                                                root: {
                                                    color: 'black',
                                                    width: '20px',
                                                    height: '20px'
                                                },
                                                menuIcon: {
                                                    fontSize: '18',
                                                    marginLeft: '12px',
                                                }
                                            }}
                                        />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
            </div>
                )}
           

            {/* Modal for Document Preview */}
            {isModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content">
                               <button className="close-button" onClick={closeModal}>
                                    <img src={clearicon} alt="Close" />
                                    Close
                                </button>
                                <iframe
                                    src={currentDocumentUrl}
                                    style={{ width: '100%', height: '100%', marginTop: '10px', flex: 1, boxSizing: 'border-box', overflow: 'auto', WebkitOverflowScrolling: 'touch' }}
                                    title="Document Preview"
                                />
                    </div>
                </div>
            )}
            {/* Pagination Controls */}
            <div className="pagination" style={{ display: filteredAffidavitRequests && filteredAffidavitRequests.length > 0 ? '' : 'none' }}>
                <button onClick={() => setCurrentPage(page => Math.max(page - 1, 1))} disabled={currentPage === 1}>
                    Previous
                </button>
                <span>Page {currentPage} of {totalPages}</span>
                <button onClick={() => setCurrentPage(page => Math.min(page + 1, totalPages))} disabled={currentPage === totalPages}>
                    Next
                </button>
            </div>

            {isAdvancedSearchOpen &&
                <AdvancedSearch
                    handleOpen={handleOpenAdvancedSearch}
                    courts={courts}
                    courtDivisions={courtDivisions}
                    returnSearchResults={handleAffidavitRequestsSearchResults}
                />
            }
        </div>
    );
};

export default RequestsList;